module.exports = __webpack_public_path__ + "static/media/match-star.02c59ac7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/match-star.svg
// module id = 1907
// module chunks = 0